import { debounce } from '@kts-front/utils';
import DOMPurify from 'dompurify';
import { action, computed, makeObservable, reaction } from 'mobx';

import { IFormFieldOptions } from 'stores/interfaces/IFormField';
import { IFormStore } from 'stores/interfaces/IFormStore';
import { normalizeStringValue } from 'utils/normalizers';

import { FieldStore } from '../FieldStore';

export type Value = string | null;
type ToServerData = string | null;

export type FieldTextStoreOptions = Partial<IFormFieldOptions<Value>> & {
  validateOnChangeDebounceMs?: number;
};

export class FieldTextStore extends FieldStore<Value> implements IFormStore<any, ToServerData> {
  constructor(options?: FieldTextStoreOptions) {
    const { validateOnChangeDebounceMs, ...fieldOptions } = options ?? {};

    super({ ...fieldOptions, defaultValue: fieldOptions.defaultValue ?? null });

    makeObservable(this, {
      serverFormat: computed,
      setFromServerFormat: action.bound,
    });

    if (validateOnChangeDebounceMs) {
      const debouncedValidate = debounce({
        func: () => {
          if (this.touched) {
            this.validate();
          }
        },
        timeout: validateOnChangeDebounceMs,
      });

      this._requiredDisposers.push(
        reaction(
          () => this.value,
          () => {
            debouncedValidate();
          },
        ),
      );
    }
  }

  /** Заполняет значение поле из серверных данных **/
  setFromServerFormat<T>(from: T): void {
    this.setValue(normalizeStringValue(from), { noTouch: true });
  }

  /** Значение поле в серверном формате **/
  get serverFormat(): ToServerData {
    return this.value === null || this.value === '' ? null : DOMPurify.sanitize(this.value);
  }
}
